module.exports = __webpack_public_path__ + "img/about.3b6851b0.jpg";